import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { TRACK_CLICK_VIEW_PROMO_CALLOUT_STORE } from '../../../../../src/web/utils/dataLayer';
import FacilityImage from '../../../../containers/FacilityImage';
import SMFacilityLink from '../SMFacilityLink';
import Translation from '../../../../components/stateless/Translation';
import SMFacilitiesListItemInfo from '../SMFacilitiesListItemInfo';
import SMFacilitiesListItemBanner from '../SMFacilitiesListItemBanner';
import SMFacilitiesListItemUnit from '../SMFacilitiesListItemUnit';
import styles from './styles.scss';


const propTypes = {
  active: PropTypes.bool,
  facility: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onHover: PropTypes.func,
  multiLocale: PropTypes.bool,
};

const defaultProps = {
  active: false,
  onHover: () => { },
  multiLocale: false,
};

const SMFacilitiesListItem = ({
  active,
  facility,
  onHover,
  multiLocale,
}) => {
  const onMouseLeave = () => onHover();
  const onMouseEnter = () => onHover(facility);
  const buttonId = facility.cheapestUnitSummary ? 'widgets.facilityList.button' : 'facilitiesmappopup.buttonalt';
  const defaultMessage = facility.cheapestUnitSummary ? 'View Deals' : 'View Details';

  return (
    <li
      className={`${styles.store} stores ${active ? styles.active : ''}`}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
    >
      <div className={`${styles.storeImgWrap}`}>
        <SMFacilitiesListItemBanner facility={facility} />
        <div className={`${styles.storeImg}`}>
          <FacilityImage
            className="absolute h-full w-full object-cover"
            facility={facility}
          />
        </div>
      </div>
      <div className="w-full p-4 min-[639px]:w-5/7 md:max-[1100px]:w-full">
        <div className={`${styles.content}`}>
          <SMFacilitiesListItemInfo facility={facility} />
          <SMFacilitiesListItemUnit facility={facility} />
        </div>
        <div className="flex justify-end">
          <SMFacilityLink
            facility={facility}
            className={`${styles.storeBtn}`}
            multiLocale={multiLocale}
            {...TRACK_CLICK_VIEW_PROMO_CALLOUT_STORE}
            tabIndex="-1"
            aria-hidden="true"
          >
            <Translation id={buttonId} defaultMessage={defaultMessage} />
          </SMFacilityLink>
        </div>
      </div>
      <SMFacilityLink
        facility={facility}
        className={`${styles.facilityOverlay}`}
        multiLocale={multiLocale}
        {...TRACK_CLICK_VIEW_PROMO_CALLOUT_STORE}
      >
        <span className="sr-only">View Deals about {facility.address.address1} {facility.address.city}, {facility.address.state} {facility.address.postal}</span>
      </SMFacilityLink>
    </li>
  );
};

SMFacilitiesListItem.propTypes = propTypes;
SMFacilitiesListItem.defaultProps = defaultProps;

SMFacilitiesListItem.fragments = {
  facility: gql`
    fragment SMFacilitiesListItemFacility on Facility {
      id
      ...FacilityImageFacility
      ...SMFacilityLinkFacility
      ...SMFacilitiesListItemBannerFacility
      ...SMFacilitiesListItemInfoFacility
      ...SMFacilitiesListItemUnitFacility
    }

    ${FacilityImage.fragments.facility}
    ${SMFacilityLink.fragments.facility}
    ${SMFacilitiesListItemBanner.fragments.facility}
    ${SMFacilitiesListItemInfo.fragments.facility}
    ${SMFacilitiesListItemUnit.fragments.facility}
  `,
};

export default SMFacilitiesListItem;
